/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/viz/shared/views/SelectorsView.js"/>
/// <reference path="~/js/viz/selectors/LocationSelectorView.js"/>
/// <reference path="~/js/viz/selectors/MultipleDataTypeSelectorView.js"/>
/// <reference path="~/js/viz/selectors/OtherFeaturesSelectorView.js"/>
/// <reference path="~/js/viz/selectors/IndicatorJumpSelectorView.js"/>

(function($, _) {
  var ns, selectorNs, sharedNs;

  ns = window.nspace("ccc.viz.profile.views");
  selectorNs = window.nspace("ccc.viz.selectors");
  sharedNs = window.nspace("ccc.viz.shared");

  ns.SelectorsView = sharedNs.views.SelectorsView.extend({
    initializeView: function() {
      // Expose this (presumably one-and-only) instance globally so that other components
      // can call "public" methods and get selector information, such as for building data summaries.
      // TODO: What's a better way to architect this?
      ns.instances = { SelectorsView: this };

      this.model.on("change", this.updateDataSummary);
    },

    initializeSelectors: function() {
      this.headerSelectors = [
        (this.locationSelectorView = new selectorNs.SingleLocationSelectorView({
          model: this.model
        }))
      ];

      this.summarySelectors = [
        (this.dataTypeSelectorView = new selectorNs.MultipleDataTypeSelectorView(
          {
            model: this.model
          }
        )),
        (this.otherFeaturesSelectorView = new selectorNs.OtherFeaturesSelectorView(
          {
            model: this.model
          }
        )),
        (this.indicatorJumpSelectorView = new selectorNs.IndicatorJumpSelectorView(
          {
            model: this.model
          }
        ))
      ];
    },

    updateDataSummary: function() {
      var summaryText;

      summaryText =
        this.getIndicatorText() +
        this.getDataSummaryText(this.summarySelectors) +
        "; " +
        this.getLocationTypeText() +
        "All Available Years";

      $(".tab-container .sub-heading").text(summaryText);
    },

    getIndicatorText: function() {
      var indicatorLength;

      indicatorLength = this.selectorInfo.indicators.length;
      return (
        indicatorLength +
        " Indicator" +
        (indicatorLength !== 1 ? "s" : "") +
        "; "
      );
    },

    getLocationTypeText: function() {
      return this.selectorInfo.locations[0].parent.name + "; ";
    },

    renderSelectors: function(selectorInfo) {
      var locationInfo, dataTypeInfo;

      locationInfo = this.shapeLocations(selectorInfo);
      this.locationSelectorView.render(locationInfo);

      dataTypeInfo = this.shapeDataTypes(selectorInfo);
      this.dataTypeSelectorView.render(dataTypeInfo);

      this.otherFeaturesSelectorView.render({
        features: [
          {
            id: "show-notes-and-definitions",
            name: "Show Notes & Description"
          },
          {
            id: "show-change-over-time",
            name: "Show Change Over Time"
          }
        ]
      });

      this.indicatorJumpSelectorView.render(selectorInfo);
    },

    shapeLocations: function(selectorInfo) {
      var locationType;

      locationType = selectorInfo.locations[0].parent;

      return {
        locationType: locationType,
        locations: selectorInfo.locations
      };
    },

    shapeDataTypes: function(selectorInfo) {
      var dataFormats, transformedDataFormats;

      dataFormats = {};

      _.each(selectorInfo.selectors, function(indicatorGroup, indicatorId) {
        _.each(indicatorGroup.dataFormats, function(dataFormat) {
          if (dataFormats[dataFormat.name]) {
            return;
          }
          dataFormats[dataFormat.name] = dataFormat;
        });
      });

      transformedDataFormats = _.map(dataFormats, function(
        dataFormat,
        dataFormatName
      ) {
        return dataFormat;
      });

      return { dataFormats: transformedDataFormats };
    }
  });
})(jQuery, _);
